import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

import { Device } from '../device.model';
import { Controller, IP, Vendor } from '../controller.model';
import { DeviceService } from '../device.service';

@Component({
  selector: 'app-device-controller-edit',
  templateUrl: './device-controller-edit.component.html',
  styleUrls: ['./device-controller-edit.component.scss']
})
export class DeviceControllerEditComponent implements OnInit {

  public deviceID: number;
  public device: Device;

  public controllerID: number;
  public controller: Controller;

  public selectedIP: IP;
  public interfaceOptions: any = {
    'interfaceType': null,
    'link': null
  }

  modalOptions:NgbModalOptions;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public deviceService: DeviceService,
    private modalService: NgbModal
  ) {
    this.modalOptions = {
      backdrop:true,
      backdropClass:'customBackdrop'
    }
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if (params.device_id || params.controller_id) {
        this.deviceID = params.device_id;
        this.device = this.deviceService.device(this.deviceID);

        this.controllerID = params.controller_id;
        this.controller = this.deviceService.controller(this.deviceID, this.controllerID);

        console.log(this.device, this.controller)

        if (!this.device || !this.controller) this.router.navigate(['/devices']);
      } else {
        this.router.navigate(['/devices']);
      }
    })
  }

  openModal(content, ipIndex: number) {
    this.selectedIP = this.controller.ips[ipIndex];

    this.modalService.open(content, this.modalOptions).result.then((result) => {
      console.log(`Closed with: ${result}`);
    }, (reason) => {
      console.log(`Dismissed ${reason}`);
    });
  }

  reboot() {
  
  }

  authenticateGuac() {
  
  }

}
